// ─────────────────────────────────────────────────────────────────────────────
// icons.js — glyphs used by the Add Node wizard. All stroked, all inheriting
// `currentColor`, so colour and size come from the button/box CSS.
// ─────────────────────────────────────────────────────────────────────────────
const base = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  viewBox: "0 0 24 24",
};

export const CloseIcon = ({ size = 16 }) => (
  <svg width={size} height={size} {...base}>
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);

export const ChevronRightIcon = ({ size = 15 }) => (
  <svg width={size} height={size} {...base}>
    <path d="m9 18 6-6-6-6" />
  </svg>
);

export const CheckCircleIcon = ({ size = 20 }) => (
  <svg width={size} height={size} {...base}>
    <circle cx="12" cy="12" r="9" />
    <path d="m8.5 12 2.5 2.5 4.5-5" />
  </svg>
);

export const DownloadIcon = ({ size = 15 }) => (
  <svg width={size} height={size} {...base}>
    <path d="M12 3v11m0 0 4-4m-4 4-4-4" />
    <path d="M4 17v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2" />
  </svg>
);

/** Open arc that the CSS spins — the "working" indicator on the progress step. */
export const SpinnerIcon = ({ size = 14 }) => (
  <svg width={size} height={size} {...base} strokeWidth="2">
    <path d="M12 3a9 9 0 1 0 9 9" />
  </svg>
);
